import { GridColDef } from "@mui/x-data-grid";
import { createdAtmodifiedAtActions } from "../../../../../helpers/appHelpers";

export const Columns: GridColDef[] = [
	{
		field: "name",
		headerName: "Name",
		minWidth: 240,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "paymentInstitution",
		headerName: "Payment Institution",
		minWidth: 240,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.name || "--",
	},
	{
		field: "description",
		headerName: "Description",
		minWidth: 350,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "sortCode",
		headerName: "Sort Code",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "active",
		headerName: "Active",
		minWidth: 140,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value ? "Yes" : "No",
	},
	
	...createdAtmodifiedAtActions
];
